import PropTypes from 'prop-types'
import CircularProgress from '@mui/material/CircularProgress'
import {styled} from '@mui/material/styles'
import loadingTitles from '../../appConfig/loadingTitles.config.json'
const StyledDiv = styled('div')(({ismapbox, theme}) => ({
  position: 'absolute',
  top: ismapbox === 'true' ? theme.spacing(1.25) : theme.spacing(-5),
  right: theme.spacing(1.25),
  zIndex: 999
}))
export default function ChartLoadingIndicator({ismapbox}) {
  return (
    <StyledDiv ismapbox={ismapbox}>
      <CircularProgress size={20} title={loadingTitles.populationDensityChart} />
    </StyledDiv>
  )
}

ChartLoadingIndicator.propTypes = {
  ismapbox: PropTypes.string
}
